import { render, staticRenderFns } from "./SpcAnalysis.vue?vue&type=template&id=cc36f420&"
import script from "./SpcAnalysis.js?vue&type=script&lang=js&"
export * from "./SpcAnalysis.js?vue&type=script&lang=js&"
import style0 from "./SpcAnalysis.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports